'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/conversations/node_modules/core-js/internals/is-pure.js
// module id = 307
// module chunks = 25